<template>
  <div>
    <component
      :is="
        cardType == 1
          ? ProductCardOneOne
          : cardType == 2
            ? LazyProductCardOneTwo
            : cardType == 3
              ? LazyProductCardTwoOne
              : cardType == 4
                ? LazyProductCardOneFour
                : cardType == 5
                  ? LazyProductCardTwoThree
                  : cardType == 6
                    ? LazyProductCardTwoFour
                    : cardType == 7
                      ? LazyProductCardOneFour
                      : cardType == 8
                        ? LazyProductCardTwoSeven
                        : cardType == 9
                          ? LazyProductCardTwoSeven
                          : cardType == 10
                            ? LazyProductCardTwoEight
                            : cardType == 11
                              ? LazyProductCardTwoNine
                              : ProductCardOneOne
      "
      :id="item?.id"
      :key="item?.id"
      :image="item?.photo_url ?? item?.thumbnail"
      :cities="item?.cities"
      :country="country"
      :title="item?.title"
      :categories="item?.categories"
      :rate="item?.rating"
      :market-price="item?.market_price?.amount || 0"
      :price="item?.starting_price?.amount || 0"
      :currency="item?.starting_price?.currency.code || '-'"
      :is-negotiable="item?.is_negotiable"
      :has-pay-later="item?.payment_options?.cash_payment"
      :deposit-percent="item?.payment_options?.pay_later?.deposit_percent || 0"
      :slug="item?.slug"
      :has-border="hasBorder"
      :discount-colors="discountColors"
      :vertical="vertical"
      :short-description="item?.short_description"
      class="w-full"
      :class="[
        { 'md:!border-0': cardType === 4 },
        { 'md:!border-0 h-[399px] md:h-[460px]': cardType === 5 },
        { 'md:!border-0 h-[460px]': cardType === 6 },
        { 'md:!border-0': cardType === 7 },
        { 'dark-mode': darkMode },
        cardClass,
      ]"
      :custom-class="customClass"
      :to-path="productRoute(item)"
      :titleClass="titleClass"
      :texts-class="textsClass"
      :price-class="priceClass"
      :pricingType="item?.pricing_type"
      :availabilityType="item?.availability_type"
      :duration="item?.duration"
      :capacity="item?.capacity"
      :hide-category-and-city="shouldHideCategoryAndCity"
      :hide-availability-type="shouldHideAvailabilityType"
    />
  </div>
</template>
<script setup lang="ts">
import { type PropType, computed, defineAsyncComponent } from "vue";
import type { IProduct } from "../../types/general";
import ProductCardOneOne from "./ProductCardOneOne.vue";
// const LazyProductCard = defineAsyncComponent(
//   () => import("./ProductCard.vue")
// );
const LazyProductCardOneTwo = defineAsyncComponent(
  () => import("./ProductCardOneTwo.vue"),
);
const LazyProductCardTwoOne = defineAsyncComponent(
  () => import("./ProductCardTwoOne.vue"),
);
const LazyProductCardOneFour = defineAsyncComponent(
  () => import("./ProductCardOneFour.vue"),
);
const LazyProductCardTwoThree = defineAsyncComponent(
  () => import("./ProductCardTwoThree.vue"),
);
const LazyProductCardTwoFour = defineAsyncComponent(
  () => import("./ProductCardTwoFour.vue"),
);
const LazyProductCardTwoSeven = defineAsyncComponent(
  () => import("./ProductCardTwoSeven.vue"),
);
const LazyProductCardTwoEight = defineAsyncComponent(
  () => import("./ProductCardTwoEight.vue"),
);
const LazyProductCardTwoNine = defineAsyncComponent(
  () => import("./ProductCardTwoNine.vue"),
);
const props = defineProps({
  cardType: { type: Number, default: 1 },
  customClass: {
    type: String,
    default: "bg-white",
  },
  item: {
    type: Object as PropType<IProduct>,
    required: true,
  },
  hasBorder: { type: Boolean, default: false },
  darkMode: { type: Boolean, default: false },
  discountColors: {
    type: String,
    default: "bg-discount-background text-primary-1",
  },
  vertical: { type: Boolean, default: false },
  titleClass: { type: String, default: null },
  textsClass: { type: String, default: null },
  priceClass: { type: String, default: null },
  country: { type: String, default: null },
  // Extra classes applied to the rendered card (e.g. the per-type slide
  // styling threaded in by HomeProductSliderOne's activities variant).
  cardClass: {
    type: [String, Array, Object] as PropType<any>,
    default: null,
  },
  // Card 4 variant that hides the category/city row. Falls back to the
  // `hideCategoryAndCity` client static so the statics-driven consumers
  // (discover/recommendation/invoice) don't each need to thread it through.
  hideCategoryAndCity: { type: Boolean, default: false },
});
const config = useRuntimeConfig();
const shouldHideCategoryAndCity = computed(
  () =>
    props.hideCategoryAndCity ||
    // card type 7 is the former ProductCardSeven layout: no category/city row
    props.cardType === 7 ||
    !!(config.public.statics as any)?.hideCategoryAndCity,
);
const shouldHideAvailabilityType = computed(
  () => !!(config.public.statics as any)?.hideAvailabilityType,
);
const { productPath } = usePath();
function productRoute(item: IProduct) {
  return productPath(item?.slug, item.cities[0]?.slug);
}
</script>
